export const colors = {

    bg1: "#e33535",
    bg2: "#F6F9FF",
    gr_bg: "#e41a1a",
    gr_bg2: "linear-gradient(90deg, #ec1c1e 0%, #e02e2e 100%)",
    copy_bg: "#122340",
    blue: "#2c97ea",
    green: "#ff2023",
    green2: "#00a76a",
    red: "#ff6f6f",
    purple: "#84479c",
    yellow: "#fbab19",
    black1: "#182B49",
    black2: "#444444",
    text1: "#555555",
    text2: "#666666",
    text3: "#969696",
    text4: "#ffffff",
    text5: "#cccccc",
    border1: "#eeeeee",
    border2: "#24406d",
    border3: "#dddddd",
    footer1: "#1a1b25",
    footer2: "#16171f",
    ftext: "#8D8E92",
    bg_white: "#ffffff",
    bg_red : "#d00000",

}

export const fonts = {

    roboto: "'Roboto', sans-serif",
    poppins: "'Poppins', sans-serif",

}